module.exports = __webpack_public_path__ + "img/20200613_094230.19463fcd.jpg";